var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V9.80721C21 9.78811 20.9997 9.76904 20.9992 9.75H15C14.0335 9.75 13.25 8.9665 13.25 8V2ZM5.25 15C5.25 14.5858 5.58579 14.25 6 14.25H11C11.4142 14.25 11.75 14.5858 11.75 15C11.75 15.4142 11.4142 15.75 11 15.75H6C5.58579 15.75 5.25 15.4142 5.25 15ZM6 18.25H14C14.4142 18.25 14.75 18.5858 14.75 19C14.75 19.4142 14.4142 19.75 14 19.75H6C5.58579 19.75 5.25 19.4142 5.25 19C5.25 18.5858 5.58579 18.25 6 18.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2768 8.24999L14.8399 2.61172C14.8108 2.58151 14.7808 2.55232 14.75 2.52417V7.99999C14.75 8.13806 14.8619 8.24999 15 8.24999H20.2768Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ba1033bc144eb9a7722b5155b7d679f1.svg";
export { ForwardRef as ReactComponent };